import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

export type UseDefaultValueProps<T> = {
  name: string
  value: T
}

/** RHF inputs with a default value are not "touched" by default, which is required for
 *  validation styling.
 *  This hook touches and validates an RHF input with a default value. */
export const useDefaultValue = <T>({ name, value }: UseDefaultValueProps<T>) => {
  const { setValue } = useFormContext()

  useEffect(() => {
    if (value) {
      setValue(name, value, {
        shouldDirty: false,
        shouldTouch: true,
        shouldValidate: true,
      })
    }
  }, [name, setValue, value])
}
